<script>
	export default {
		name: 'MenuExecuter',
		methods: {
			openMenu(menu) {
				const self_ = this;
				const router_ = self_.$router;

				const menuItems_ = self_.getAppContents('menuItems')

				const to_ = {
					name: 'page',
					params: { 
						pageName: menuItems_[menu].page.name,
						pageType: menuItems_[menu].page.type
					}
				}

				router_.push(to_)
			},
			switchMenuGroup(menuGroup) {
				const self_ = this;

				const menuGroups_ = self_.getAppContents('menuGroups')
				const cookie_ = self_.getCookie('menuGroup')

				let key_ = null;
				// switch to default menu group
				if(self_.isFalse(menuGroup) && self_.isFalse(cookie_)) { 
					const default_ = self_.findObject(menuGroups_, 'isDefault', true)
					key_ = default_.key;
				}
				// switch to menu group in cookie
				else if(self_.isFalse(menuGroup)) {
					key_ = cookie_;
				}
				// switch to target menu group
				else {
					key_ = menuGroup;
				}

				self_.setAppState('menuGroup', key_)
				self_.setCookie('menuGroup', key_)
			}
		}
	}
</script>